const deliveryMethod = [
  { id: 'EMAIL', name: 'EMAIL' },
  { id: 'MAIL', name: 'MAIL' }
];

const deliveryMethodToDisplay = [
  { id: 'FAX', name: 'FAX' },
  { id: 'FEDEX', name: 'FEDEX' }
];

export default { deliveryMethod, deliveryMethodToDisplay };
